// https://docs.microsoft.com/de-de/windows/uwp/publish/trademark-and-copyright-protection

const Policy = () => {
    return ("HELLO Policy!")
  }
  export default Policy;